// Before/After slider (port of inline script index.html 1092-1151).
function initBeforeAfter() {
  const ba = document.getElementById('ba-slider');
  if (!ba) return;
  const after = document.getElementById('ba-after');
  const divider = document.getElementById('ba-divider');
  const handle = document.getElementById('ba-handle');
  const labelAfter = document.getElementById('ba-label-after');
  const labelBefore = document.getElementById('ba-label-before');
  const EDGE = 6;
  let dragging = false;

  function setPos(clientX) {
    const r = ba.getBoundingClientRect();
    let pct = ((clientX - r.left) / r.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    after.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
    divider.style.left = pct + '%';
    handle.style.left = pct + '%';
    if (labelAfter)  labelAfter.style.opacity  = pct < EDGE       ? '0' : '1';
    if (labelBefore) labelBefore.style.opacity = pct > 100 - EDGE ? '0' : '1';
  }
  function onMove(e) { if (dragging) { e.preventDefault(); setPos(e.clientX); } }
  function onUp() {
    dragging = false;
    ba.classList.remove('is-dragging');
    document.removeEventListener('pointermove', onMove);
    document.removeEventListener('pointerup', onUp);
    document.removeEventListener('pointercancel', onUp);
  }
  ba.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    dragging = true;
    ba.classList.add('is-dragging');
    setPos(e.clientX);
    document.addEventListener('pointermove', onMove, { passive: false });
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onUp);
  });

  ba.setAttribute('tabindex', '0');
  ba.setAttribute('role', 'slider');
  ba.setAttribute('aria-label', 'Before / After');
  ba.setAttribute('aria-valuemin', '0');
  ba.setAttribute('aria-valuemax', '100');
  ba.setAttribute('aria-valuenow', '50');
  ba.addEventListener('keydown', (e) => {
    const cur = parseFloat(divider.style.left) || 50;
    let next = cur;
    if (e.key === 'ArrowLeft')       next = Math.max(0, cur - 5);
    else if (e.key === 'ArrowRight') next = Math.min(100, cur + 5);
    else if (e.key === 'Home')       next = 0;
    else if (e.key === 'End')        next = 100;
    else return;
    e.preventDefault();
    const r = ba.getBoundingClientRect();
    setPos(r.left + (next / 100) * r.width);
    ba.setAttribute('aria-valuenow', String(Math.round(next)));
  });
}

if (document.readyState !== 'loading') initBeforeAfter();
else document.addEventListener('DOMContentLoaded', initBeforeAfter);
